<template>
    <div class="card">
        <!-- <div class="container-fluid">
            <div style="padding-top:20px;" class="form-group row">
                <div class="col-sm-12">
                    <button @click="openCitizenModal()" class="btn btn-primary pull-right">সিটিজেন খুঁজুন</button>
                </div>
            </div>
            <form style="padding-top:5px;" @submit.prevent="test" >

                <div class="form-group row">
                    <label  class="col-sm-4 col-form-label">মোবাইল নাম্বার</label>
                    <div class="col-sm-8">
                        <input name="Phone" v-validate="'required|numeric'" v-model="user.mobile_number" type="text" class="form-control"  placeholder="মোবাইল নাম্বার">
                        <div v-show="errors.has('Phone')" style="color:red">
                            {{ errors.first('Phone') }}
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label  class="col-sm-4 col-form-label">জাতীয় পরিচয় নাম্বার</label>
                    <div class="col-sm-8">
                        <input name="NID" v-validate="'required|numeric'" v-model="user.nid" type="text" class="form-control"  placeholder="জাতীয় পরিচয় নাম্বার">
                        <div v-show="errors.has('NID')" style="color:red">
                            {{ errors.first('NID') }}
                        </div>
                    </div>
                </div>
            <div class="form-group row">
                <div class="col-sm-12">
                <input v-if="!addLoader" type="submit" value="Submit" class="btn btn-primary pull-right"/>
                <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
                <button v-if="!addLoader"  @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                </div>
            </div>
        </form>
        </div> -->
        <div  v-if="this.permissions.priority == 3 && permission.water_update_create" class="container-fluid mt-1 mb-1">
            <button type="button" @click="openCitizenModal()" class="btn btn-primary contct-b pull-left"><i class="fa fa-refresh"></i> সংযোগ হালনাগাদ আবেদন</button>
            <!-- <form class="form-inline contct my-2 my-lg-0 pull-right">
                <input v-model="search.search_item" class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
                <button @click.prevent="searchContact" class="btn btn-outline-success my-2 my-sm-0" >Search</button>
            </form> -->
        </div>
        <div  class="container-fluid" style="overflow: auto;">
            <table id="my-table" class="table table-striped table_fields">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">হিসাব নাম্বার</th>
                        <th scope="col">সেবা</th>
                        <th style="text-align:right" scope="col">ফি</th>
                        <th scope="col">স্ট্যাটাস</th>
                        <th v-for="(status,key) in statuses" :key="key" scope="col"><small>{{status}}</small><br><small>স্ট্যাটাস</small></th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(application,key) in allApplication.data" :key="key">
                        <td>{{key+1}}</td>
                        <td><span v-if="application.user">{{application.user.name}}</span><br><span v-if="application.application">{{application.application.account_no}}</span><br><span v-if="application.user">{{application.user.mobile_number}}</span></td>

                        <td><span v-if="application.service">{{application.service.name}}</span></td>
                        <td style="text-align:right"><span v-if="application.service">{{application.service.connection_fee + application.adjustment}} /-</span></td>
                        <!-- <td><span v-if="application.updated_by">{{application.updated_by.name}}</span></td> -->
                        <td><span v-if="application.status == 0" style="color:peru">Pending</span><span v-if="application.status == 1" style="color:green">Approved</span> <span v-if="application.status == 2" style="color:red">Remove</span></td>
                        <td v-if="statuses.includes('অ্যাডমিন')==true"><span @click="viewApproveDetails(application,key,3)" :style="application.confirm_3?'color:green':'color:#888'" style="font-size:12px;cursor:pointer;padding: 4.2px 5px; border-radius: 12px;border: 1px solid;"><i class="fa fa-check"></i></span><sub v-if="application.confirm_2"><i class="fa fa-lock"></i></sub></td>
                        <td v-if="statuses.includes('সচিব')==true"><span @click="viewApproveDetails(application,key,2)" :style="application.confirm_2?'color:green':'color:#888'" style="font-size:12px;cursor:pointer;padding: 4.2px 5px; border-radius: 12px;border: 1px solid;"><i class="fa fa-check"></i></span><sub v-if="application.confirm_1"><i class="fa fa-lock"></i></sub></td>
                        <td v-if="statuses.includes('মেয়র')==true"><span @click="viewApproveDetails(application,key,1)" :style="application.confirm_1?'color:green':'color:#888'" style="font-size:12px;cursor:pointer;padding: 4.2px 5px; border-radius: 12px;border: 1px solid;"><i class="fa fa-check"></i></span></td>
                        <td><i v-if="permission.water_update_view" @click="viewDetails(application,key)" style="font-size:22px;" class="icon-eye icons actn"> </i></td>
                    </tr>
                </tbody>
            </table>
            <nav v-if="loading==false" aria-label="Page navigation example">
                <pagination :limit="5" :data="allApplication" @pagination-change-page="getResults"></pagination>
            </nav>

            <!-- <AddContactModal ref="add_contact_modal"></AddContactModal>
            <EditContactModal :list='list' ref="edit_contact_modal"></EditContactModal>
            <ViewContactModal ref="view_contact_modal"></ViewContactModal> -->
            <!-- <Loader v-if="loading"></Loader> -->
        </div>
        <findUser @userInfo='userInfo' ref="find_user" />
        <addModal  ref="add_application" />
        <beforeAddModal @updateInfo='updateInfo' ref="before_add_application" />
        <viewModal :type="type" :my_title="my_title" ref="view_application" />

    </div>
</template>

<script>
import viewModal from '@/views/application/water/view_application';
import axios from "axios"
import pagination from 'laravel-vue-pagination'
import beforeAddModal from '@/views/application/water/update_connection_before_add';
import addModal from '@/views/application/water/update_connection_add';
import findUser from '@/views/application/others/find_user_modal';
import { ALL_APPLICATION } from "@/store/action.type"
import { mapGetters } from "vuex"
export default {
    data(){
        return {
            loading:false,
            permission:'',
            search:{
                search_item:''
            },
            user:{
                nid:'',
                mobile_number:''
            },
            my_title: 'পানির সংযোগ হালনাগাদ',
            type: 'update-water-connection',
            statuses:[],
            permissions:{},
            priority:JSON.parse(this.$user.permission.permission).priority,
        }
    },
    methods:{
        viewDetails(data,key){
            this.$refs.view_application.openModal(data,key,this.statuses)
        },
        viewApproveDetails(data,key,own){
            if(this.permissions.priority == 3 && own == this.permissions.priority && !data.confirm_2){
                this.$refs.view_application.openModal(data,key,this.statuses)
            }
            else if(this.permissions.priority == 2 && own == this.permissions.priority && !data.confirm_1){
                this.$refs.view_application.openModal(data,key,this.statuses)
            }
            else if(this.permissions.priority == 1 && own == this.permissions.priority){
                this.$refs.view_application.openModal(data,key,this.statuses)
            }
        },
        userInfo(data){
            this.$refs.before_add_application.openModal(data)
        },
        updateInfo(data){
            this.$refs.add_application.openModal(data)
        },
        openCitizenModal(){
            if(this.$user.type == 2){
                var user = {
                    nid:this.$user.nid,
                    mobile_number:this.$user.mobile_number,
                    project_category_id:1
                }
                axios.post("/api/application-user",user).then(response=>{
                    this.userInfo(response.data)
                })
            }
            else{
                this.$refs.find_user.openModal()
            }
        },
        test(){
            alert('ok');
        },
        getResults(page = 1){
            var data = {type:'update-water-connection', page:page}
            this.$store.dispatch('ALL_APPLICATION',data)
        },
        async permissionSS(){
            await axios.post("/api/permissons/priority").then(response=>{
                this.statuses = response.data.role_name
                this.permissions = response.data.permisson[0]
                this.user_id = this.$user.id
            })
        },
        allRole(){
            this.$store.dispatch('ALL_USER_ROLE')
        },
        getPermission(){
            this.$store.dispatch('ALL_USER_ROLE2')
            .then(response=>{
                this.permission = response.data.permission
            })
        }
    },

    mounted(){
        this.permissionSS()
        this.getResults()
        this.allRole()
        this.getPermission()
    },
    computed: {
        ...mapGetters(["allApplication","user_roles"]),
    },
    components:{
       findUser,
       addModal,
       pagination,
       beforeAddModal,
       viewModal
    }
}
</script>


<style>
.breadcrumb{
    margin-bottom: 1rem;
}
.main .container-fluid{
    padding: 0 16px;
}
 .actn{
     margin-left: 10px;
     cursor: pointer;
 }
 .contct{
     padding-bottom: 10px;
     padding-top: 10px
 }
 .contct-b{
     margin-bottom: 10px;
     margin-top: 10px
 }
 .load{
     margin-left: 50%;
 }
</style>
